export default __webpack_public_path__ + "static/home1-4da95af94f5421da093662fdfb5db6a7.webp";